import React from 'react';
import './userBar.css';
import { useDispatch, useSelector } from "react-redux";
import { setUserAction, setUserBarAction } from "../../redux/actions";
import Auth from "../Auth/Auth";
import UserData from "../UserData/UserData";
import { USER_INITIAL } from "../../redux/initialStateConstants";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getBookingSagaAction } from "../../redux/sagaActions";

const UserBar = () => {
    const dispatch = useDispatch();
    const user_bar = useSelector(state => state.user_bar);
    const user = useSelector(state => state.user);

    return (
        <div className={ `ubar ${ user_bar ? 'ubar--visible' : '' }` }>
            <div className="ubar__header">
                <div className="ubar__close" onClick={ () => dispatch(setUserBarAction(false)) }/>
                <div className="ubar__title">{
                    user.id ? 'Ваши абонементы' : 'Авторизация'
                }</div>
            </div>

            <div className="ubar__content">
                {
                    user.id
                    ?
                        <UserData/>
                    :
                        <Auth/>
                }
            </div>

            {
                user.id && <div className="ubar__signout button"
                    onClick={ () => {
                        setLocalStorage('afw_u', '').then();
                        dispatch(setUserAction(USER_INITIAL));
                        dispatch(setUserBarAction(false));

                        // Запрашиваем расписание
                        dispatch(getBookingSagaAction());
                    } }
                >Выйти</div>
            }
        </div>
    );
};

export default UserBar;